'use client';
import Link from '@/components/WrappedLink';
import Image from 'next/image';
import { websiteLogoAr, websiteLogoEn } from '../../../../public/Images';
import { AVAILABLE_LANGUAGES } from '@/constants';
export default function NavBarSylndrLogoOnly({
    lang,
}: {
    lang: AVAILABLE_LANGUAGES;
}) {
    return (
        <nav
            className={
                'mx-auto flex items-center w-full h-20 bg-white md:justify-between px-4 md:px-[5%] border-b border-b-gray-200'
            }
        >
            <Link href={`/${lang}`}>
                <Image
                    width={160}
                    height={25.5}
                    className={
                        'en:md:w-36 ar:md:w-[129px] w-[100px] object-contain align-middle ar:h-10'
                    }
                    src={lang === 'en' ? websiteLogoEn : websiteLogoAr}
                    alt="Sylndr's Logo"
                    dir={lang === 'ar' ? 'rtl' : 'ltr'}
                />
            </Link>
        </nav>
    );
}
